const getIsProductShownForQuickshipFilter = ({
  activeFilters,
  variants,
  algoliaHits,
}) => {
  const isQuickshipFilterActive = activeFilters?.quickship?.length > 0;

  if (!isQuickshipFilterActive) {
    return true;
  }

  // For search pages with Algolia hits, filtering is done server-side via Algolia facetFilters
  if (algoliaHits?.length > 0) {
    return true;
  }

  // For non-search pages (categories, PDP), use variant-based client-side filtering
  const productHasReadyToShipOptions = variants.some(
    ({ quickship }) => quickship
  );

  return productHasReadyToShipOptions;
};

export default getIsProductShownForQuickshipFilter;
